export default {
  getUserEtcInfo: state => state.userEtcInfo,
  getDivisionInfo: state => state.divisionInfo,
  getAllDivisionInfo: state => state.allDivisionInfo,
  getUserDivisionInfo: state => state.userDivisionInfo,
  getUserDivisionList: state => state.userDivisionList,
  getDivSelectOne: state => state.divSelectOne,
  getCurrentDivList: state => state.currentDivList,
  getSelectRole: state => state.selectRole,
  getDivisionListWithSecurityMgmt: state => state.divisionListWithSecurityMgmt,
};



// WEBPACK FOOTER //
// ./src/vuex/userdiv/userdivGetter.js